export enum CodigoProductoEnum {
    ARRIENDO_LITE_POS = 'ARRIENDO_LITE_POS',
    ARRIENDO_MPOS = 'ARRIENDO_MPOS',
    ARRIENDO_PACK_CELULAR = 'ARRIENDO_PACK_CELULAR',
    ARRIENDO_PACK_INTERNET = 'ARRIENDO_PACK_INTERNET',
    ARRIENDO_POS_FIJO_CELULAR = 'ARRIENDO_POS_FIJO_CELULAR',
    ARRIENDO_POS_FIJO_INTERNET = 'ARRIENDO_POS_FIJO_INTERNET',
    ARRIENDO_POS_MOVIL = 'ARRIENDO_POS_MOVIL',
    ARRIENDO_POS_MOVIL_20DIAS = 'ARRIENDO_POS_MOVIL_20DIAS',
    ARRIENDO_POS_MOVIL_90DIAS = 'ARRIENDO_POS_MOVIL_90DIAS',
    ARRIENDO_POS_MOVIL_FERIA = 'ARRIENDO_POS_MOVIL_FERIA',
    ARRIENDO_SMARTPOS = 'ARRIENDO_SMARTPOS',
    BASE = 'base',
    COBRA_CON_LINK_PAGO = 'COBRA_CON_LINK_PAGO',
    COBRO_QR = 'COBRO_QR',
    CREA_TU_SITIO_WEB_CON_PST = 'CREA_TU_SITIO_WEB_CON_PST',
    CREA_TU_SITIO_WEB_CON_WIX = 'CREA_TU_SITIO_WEB_CON_WIX',
    CREACION_SITIO_ALIANZA_WIX = 'CREACION_SITIO_ALIANZA_WIX',
    CREACION_SITIO_PST = 'CREACION_SITIO_PST',
    INTEGRA_MEDIO_PAGO_CON_TRANSBANK = 'INTEGRA_MEDIO_PAGO_CON_TRANSBANK',
    INTEGRA_MEDIO_PAGO_POR_TU_CUENTA = 'INTEGRA_MEDIO_PAGO_POR_TU_CUENTA',
    INTEGRADOR_CLIENTE = 'INTEGRADOR_CLIENTE',
    INTEGRADOR_TRANSBANK = 'INTEGRADOR_TRANSBANK',
    LINK_PAGO = 'LINK_PAGO',
    PACK_POS_MOVIL_LP="PACK_POS_MOVIL_LP",
    PACK_VENTA_MPOS_LP = 'PACK_VENTA_MPOS_LP',
    PACK_VENTA_MPOS_LP_GARANTIA = 'PACK_VENTA_MPOS_LP_GARANTIA',
    VENTA_MPOS = 'VENTA_MPOS',
    VENTA_MPOS_GARANTIA = 'VENTA_MPOS_GARANTIA'
}
